import { NgModule } from '@angular/core';
import { CurrentBranchFormComponent } from './current-branch-form.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
@NgModule({
    declarations: [CurrentBranchFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule.forRoot(),
    ],
    exports: [CurrentBranchFormComponent]
})
export class CurrentBranchModule { }